export const KPI_LABELS = [
  {
    key: "activeProjects",
    label: "Active Projects",
    subtitle: "Active Projects",
  },
  {
    key: "projectApproved",
    label: "Total Projects Approved",
    subtitle: "Total Projects Approved",
  },
  {
    key: "incentiveApproved",
    label: "Total Incentives Approved",
    subtitle: "Total Incentives Approved",
  },
  {
    key: "totalStorage",
    label: "Total Storage Capacity Approved",
    subtitle: "Total Storage Capacity Approved",
  },
  {
    key: "totalSolar",
    label: "Total Solar Capacity Approved",
    subtitle: "Total Solar Capacity Approved",
  },
  {
    key: "projectInstalled",
    label: "Total Projects Installed",
    subtitle: "Total Projects Installed",
  },
  {
    key: "incentivePaid",
    label: "Total Amount Paid",
    subtitle: "Total Amount Paid",
  },
  {
    key: "totalStorageInstalled",
    label: "Total Storage Capacity Installed",
    subtitle: "Total Storage Capacity Installed",
  },
  {
    key: "totalSolarInstalled",
    label: "Total Solar Capacity Installed",
    subtitle: "Total Solar Capacity Installed",
  },
];

export const DONUT_CHARTS_CONFIG = [
  {
    title: "OEM Project Distribution",
    dataKey: "oemMetrics",
    valueLabel: "Total",
    valueField: "count",
    labelField: "name",
    colorField: "color",
    totalField: "count",
    isCurrency: false,
  },
  {
    title: "OEM Distribution Based on Incentives",
    dataKey: "oemIncentiveDistribution",
    valueLabel: "Total",
    valueField: "amount",
    labelField: "name",
    colorField: "color",
    totalField: "amount",
    isCurrency: true,
  },
  {
    title: "Project Distribution by Customer Type",
    dataKey: "nemDistribution",
    valueLabel: "Total",
    valueField: "count",
    labelField: "type",
    colorField: "color",
    totalField: "count",
    isCurrency: false,
  },
  {
    title: "Incentive Distribution by Customer Type",
    dataKey: "marketRateDistribution",
    valueLabel: "Total",
    valueField: "amount",
    labelField: "type",
    colorField: "color",
    totalField: "amount",
    isCurrency: true,
  },
];

// Color palettes for donut charts
export const OEM_COLORS = [
  "#0096FF",
  "#FFB800",
  "#FF7043",
  "#FFD600",
  "#00C49A",
  "#A259FF",
  "#FF616D",
  "#FFB74D",
];

export const CUSTOMER_TYPE_COLORS = {
  "Market Rate": "#0096FF",
  "CARE/FERA": "#FFB800",
  "Communities of Concern": "#FF7043",
  Other: "#FFD600",
};

export const RATE_TYPE_COLORS = {
  CARE: "#FFB800",
  FERA: "#FF7043",
  "Market Rate": "#0096FF",
  "Communities of Concern": "#FFD600",
};
